import angular from 'angular'

/**
 * The second level sidebar component that sits parrellel with the side tabs, will contain the sub menu items
 */
angular.module('vend.ui').directive('vdSidebarDrawer', function () {
  return {
    link(scope, $element, attrs) {
      attrs.$addClass('vd-sidebar-drawer')
      attrs.$set('role', 'navigation')
    },
  }
})
